import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://bmsoqhiwxfodeqfypyha.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJtc29xaGl3eGZvZGVxZnlweWhhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MjY2MzUsImV4cCI6MjA5MzQwMjYzNX0.60divq70ZWz6Pl-kBIp9sHbFUWFHbvn_gQimqDpcMUY'
);

export default supabase;